import { Action } from '@ngrx/store';
import { DestinationCenter } from '@app/models/destination-center';

export enum DestinationCenterActionTypes {
  Load = '[API] Load Destination center',
  LoadAll = '[API] Load All Destination center',
  LoadSuccess = '[API] Load Destination center success',
  LoadFail = '[API] Load Destination center fail',

  // GetAll = '[API] Load All Destination center',
  // GetAllSuccess = '[API] Load Destination center success',
  // GetAllFail = '[API] Load Destination center fail',

  Update = '[API] Update Destination center',
  UpdateSuccess = '[API] Update Destination center success',
  UpdateFail = '[API] Update Destination center fail',

  Create = '[API] Create Destination center',
  CreateSuccess = '[API] Create Destination center success',
  CreateFail = '[API] Create Destination center fail',

  Delete = '[API] Delete Destination center',
  DeleteSuccess = '[API] Delete Destination center success',
  DeleteFail = '[API] Delete Destination center fail',

  SelectedBusiness = '[Selected Business] get selected business',
  SelectedBusinessSuccess = '[Selected Business] get selected business success',
  SelectedBusinessFail = '[Selected Business] get selected business fail',

  ClearDestinationCenters = '[Clear Destination Centers] Clear destination centers'
}

export class Load implements Action {
  readonly type = DestinationCenterActionTypes.Load;
  constructor(public FollowId?: any) {}
}

export class LoadAll implements Action {
  readonly type = DestinationCenterActionTypes.LoadAll;
  constructor(){}
}

export class LoadSuccess implements Action {
  readonly type = DestinationCenterActionTypes.LoadSuccess;
  constructor(public destinationCenters: any[]) {}
}

export class LoadFail implements Action {
  readonly type = DestinationCenterActionTypes.LoadFail;
  constructor(public error: any) {}
}

// export class GetAll implements Action {
//   readonly type = DestinationCenterActionTypes.GetAll;
//   constructor(){}
// }

// export class GetAllSuccess implements Action {
//   readonly type = DestinationCenterActionTypes.GetAllSuccess;
//   constructor(public destinationCenters: any[]) {}
// }

// export class GetAllFail implements Action {
//   readonly type = DestinationCenterActionTypes.GetAllFail;
//   constructor(public error: any) {}
// }

export class Update implements Action {
  readonly type = DestinationCenterActionTypes.Update;
  constructor(public id: number, public destination: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = DestinationCenterActionTypes.UpdateSuccess;
  constructor(public data: any) {}
}

export class UpdateFail implements Action {
  readonly type = DestinationCenterActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = DestinationCenterActionTypes.Create;
  constructor(public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = DestinationCenterActionTypes.CreateSuccess;
  constructor(public data: any) {}
}

export class CreateFail implements Action {
  readonly type = DestinationCenterActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class Delete implements Action {
  readonly type = DestinationCenterActionTypes.Delete;
  constructor(public data: any) {}
}

export class DeleteSuccess implements Action {
  readonly type = DestinationCenterActionTypes.DeleteSuccess;
  constructor(public data: any) {}
}

export class DeleteFail implements Action {
  readonly type = DestinationCenterActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export class SelectedBusiness implements Action {
  readonly type = DestinationCenterActionTypes.SelectedBusiness;
  constructor(public businessUnit: any, public CountryId: number) {}
}

export class ClearDestinationCenters implements Action {
  readonly type = DestinationCenterActionTypes.ClearDestinationCenters;
  constructor() {}
}

export type DestinationCenterActionsUnion =
  | Load
  | LoadAll
  | LoadSuccess
  | LoadFail
  // | GetAll
  // | GetAllSuccess
  // | GetAllFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | Create
  | CreateSuccess
  | CreateFail
  | Delete
  | DeleteSuccess
  | DeleteFail
  | SelectedBusiness
  | ClearDestinationCenters;
